<template>
	<div  class="notfound-container d-flex flex-column h-100">
		<section class="col-md-4 container">
			<div class="form-upgrade card">
				<div class="row">
					<div class="col-md-12">
						<div class="upgrade-heading">
							<h2 class="py-3 heading">{{ popupTitle }}</h2>
						</div>
						<div class="upgrade-plan py-3">
							<p>
								{{ popupDescription }}
							</p>
							<div class="buttons">
								<a
									@click="onclickaddSubscription"
									class="btn btn-outline-light btn-lg "
									v-if="popupType === 'add_subscription'"
								>
									Add Subscription
								</a>
								<span v-if="popupType === 'renew_subscription'">
									<a
										v-if="showRenewCard"
										@click="renewSubscription"
										class="btn btn-outline-light btn-lg "
									>
										Renew
									</a>
									<a
										v-if="showUpdateCard"
										@click="updateCard"
										class="btn btn-outline-light btn-lg ml-2"
									>
										Update Card
									</a>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "Popup",
	components: {},
	data() {
		return {
			socialMedia: [],
			popupType: null,
			popupTitle: null,
			popupDescription: null,
			previousSubsList: null,
			renewSubsId: null,
			renewPaymentgateway: null,
			paymentStatus:null
		};
	},

	created() {
		// this.socialMedia = JSON.parse(
		//   this.$store.state.globalconfigs.footer_social_icon
		// );
		this.init();
		this.popupType = this.$store.state.popupType;
		this.setPopupText();
	},
  beforeDestroy(){
 this.$store.commit("showPopup", false);
  },
	computed: {
		showUpdateCard() {
			if (this.renewPaymentgateway == "stripe") {
				return true;
			} else if (this.renewPaymentgateway == "braintree") {
				return true;
			}
			return false;
		},
		showRenewCard() {
			if (this.renewPaymentgateway == "stripe") {
				return true;
			} else if (this.renewPaymentgateway == "braintree") {
				return true;
			} else if (this.renewPaymentgateway == "flutterwave") {
				return true;
			}
			return false;
		},
	},

	methods: {
		getText(val) {
			return this.$store.state.globalconfigs[val];
		},
		previousSubsPlan() {
			if (this.previousSubsList.length > 0) {
				this.renewSubsId = this.previousSubsList[0].sub_id;
				this.renewPaymentgateway = this.previousSubsList[0].payment_gateway;
				this.paymentStatus=this.previousSubsList[0].paymentStatus;
			}
		},

		onclickaddSubscription() {
			this.$router.push("/packages");
		},
		// renewSubscription() {
		// 	var dataToSend = {
		// 		subscriptionId: this.renewSubsId,
		// 		slug: this.renewPaymentgateway,
		// 	};
		// 	this.$store.commit("setLoader", true);
		// 	this.$store
		// 		.dispatch("retryPayment", dataToSend)
		// 		.then((res) => {
		// 			this.$store.commit("setLoader", false);
		// 			if (res.status == 200) {
		// 				this.$store.commit(
		// 					"setNotification",
		// 					" Payment Request sent Sucessfully!! "
		// 				);
						
		// 			}
		// 		})
		// 		.catch((err) => {
		// 			this.$store.commit("setLoader", false);
		// 			this.$store.commit("setNotification", " Error while making payment ");
		// 			this.$router.push("/account");
		// 		});
		// },
    renewSubscription(){
      this.$router.push("/packages");
    },
		updateCard() {
      		 this.$store.commit("showPopup", false);
			if (this.renewPaymentgateway == "stripe") {
				this.$router.push("/striperenewupdatecard");
			} else if (this.renewPaymentgateway == "braintree") {
				this.$router.push("/braintreerenewupdatecard");
			}
		},
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		setPopupText() {
			if (this.popupType === "add_subscription") {
				this.popupTitle = "No Active Subscription";
				this.popupDescription =
					"You have no active subscription, Kindly add subscription to start watching movies";
			} else if (this.popupType === "renew_subscription") {
				this.popupTitle = "Subscription Expired";
				this.popupDescription =
					"Your subscription has expired, Kindly subscribe to start watching movies";
			}
		},
		init() {
			this.$store.commit("setLoader", true);
			this.$store.dispatch("account").then((res) => {
				if (res) {
					this.data = res.response;
					this.previousSubsList = res.response.subscriptionList;
					this.previousSubsPlan();
					if (
						this.data.paymentProvider == "dpo" &&
						this.data.subscriptions.length == 0
					) {
						this.popupType = "add_subscription";
						this.setPopupText();
					}
				}
				this.$store.commit("setLoader", false);
			});
		},
	},
};
</script>
<style scoped>
.container {
	align-items: center;
	padding-top: 15%;
}
.card {
	border-radius: 20px;
}
.buttons {
	display: flex !important;
	justify-content: center !important;
	padding-bottom: 30px;
	padding-top: 30px;
	color: aliceblue;
	font-size: 20px;
}

.upgrade-plan > p {
	padding-top: 0px;
	padding-bottom: 5px;
	margin-top: 0px;
	margin-bottom: 0px;
	font-size: 20px;
	text-align: center;
	display: flex !important;
	justify-content: center !important;
	padding-left: 40px;
	padding-right: 40px;
}

.upgrade-heading {
	padding-top: 10px;
	display: flex !important;
	justify-content: center !important;
}

.heading {
	display: flex !important;
	justify-content: center !important;
}

.notfound-container {
	content: "";
	position: sticky;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	display: block;
	width: 100%;
	overflow: hidden;
	min-height: 100vh !important;
	z-index: 100;
	background-blend-mode: overlay;
	background-color: rgba(103, 159, 61, 0.88);
}

.screen-limit {
	background: #679f3d;
	color: #f1f2f2;
	text-align: center;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

#home {
	position: sticky;
}
</style>
